<section id="services">
    <!-- Section Content -->
    <div class="box-grey">
        <div class="wrapper">
            <div class="row margin-none col-half">
                <div class="col-md-4 col-sm-12 half padding-all">
                    <!-- <p><img src="assets/img/works-1-big.png" alt="Services" class="img-full"></p> -->
                    <h1 class="title-big letter-spacing line-bottom left">संस्थेच्या शाखा</h1>
                    <p>संस्थेनी बँकेचे खातेदार / सभासदांसाठी त्यांच्या सोइ साठी नागपूर जिल्यात ४ ठिकाणी आपल्या बँकेच्या शाखा विस्तार केला आहे. या सर्व शाखा कोर बँकिंग सर्विसेस नि जोडल्या आहे. जेणे करून सभासद आपले व्यवहार सोईस्कर रित्या करू शकता. संस्थेच्या
                        शाखा व IFSC कोडे पुढील प्रमाणे आहे.</p>
                    <div class="space "></div>
                    <p><a routerLink="/contact " class="btn btn-dark letter-spacing ">संपर्क</a></p>
                </div>

                <div class="col-md-8 col-sm-12 half padding-all box-white ">
                    <app-branch-address></app-branch-address>
                </div>
            </div>
        </div>
    </div>
    <!-- Section Content End -->
</section>
